export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/elearning.f7531d6.svg";